export default __webpack_public_path__ + "static/media/Trade_Gothic_LT.237634e1.woff";